import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep, cloneDeepWith} from "lodash";
import * as $ from "jquery";

@Component({
	selector: 'app-modal-loader-estimation',
	templateUrl: './modal-loader-estimation.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-loader-estimation.component.less']
})
export class ModalLoaderEstimationComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	modalData: any;
	interval: any;
	timeToShow: number = 5;
	showBareme: boolean = false;
	showAlgoSrf: boolean = false;
	showAlgoPresta: boolean = false;
	showDevis: boolean = false;

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		this.getInfosInit();
	}

	getInfosInit() {
		// Get global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.loaderEstimation;

				//let timeToShow: number = 5;
				let modalOpen = JSON.parse(localStorage.getItem('modalOpen')!);
				this.modalData = (modalOpen) ? modalOpen.data : "";

				this.interval = setInterval(() => {
					if (this.timeToShow > 0) {
						this.timeToShow--;
						//console.log("this.timeToShow ==> ", this.timeToShow);
						if (this.timeToShow < 5) this.showBareme = true;
						if (this.timeToShow < 4) this.showAlgoSrf = true;
						if (this.timeToShow < 3) this.showAlgoPresta = true;
						if (this.timeToShow < 2) this.showDevis = true;
					}
				}, 1005);
			})
		});
	}

}
